<template>
  <div class="map_div">
    <baidu-map
      :center="center"
      :scroll-wheel-zoom="true"
      :zoom="zoom"
      @ready="handler"
      class="bm-view"
      :enableMapClick="false"
      :mapClick="false" 
      @rightclick="clickBmap"
    >
      <bm-geolocation
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        :showAddressBar="true"
        :autoLocation="true"
      ></bm-geolocation>
       <bm-marker
        :position="markerPo"
        :title="storeName"
        :zIndex="999999999"
        @click="infoWindowOpen"
      >
        <bm-info-window
          :show="isShowInfo"
          @close="infoWindowClose"
          @open="infoWindowOpen"
          >{{address}}</bm-info-window
        >
      </bm-marker>

    </baidu-map>
  </div>
</template>

<script>
export default {
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 3,
      BMap: null,
      map: null,
      geoc: null,
      markerPo: {
        lng: 39.9,
        lat: 116.3,
      },
      storeName: "123",
      isShowInfo: true,
      address:''

    };
  },
  props: {
    detail: {
      type: Object,
      default: () => {
        return {
          lift: {},
          liveImageDataList: [],
          logList: []
        };
      },
    },
  },
  created() {},
  watch: {
    detail: {
      handler: function(val, val2) {
        if (val && val.logList && val.logList.length) {
          this.setPoint(val.logList[val.logList.length-1])
        }
      },
      deep: true,
    }
  },
  methods: {
    handler({ BMap, map }) {
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15;
      this.geoc = new BMap.Geocoder();
      this.map = map;
      this.BMap = BMap;
    },
    setCenter(val) {
      this.geoc.getPoint(val, (point) => {
        if (point) {
          this.map.centerAndZoom(point,16);
        }
      }, val)
    },
    infoWindowClose() {
      //弹框关闭
 
      this.isShowInfo = false;
    },
 
    infoWindowOpen() {
      //弹框打开
 
      this.isShowInfo = true;
    },
    showPanel() {
      //点击标注出现弹框
 
      this.isShowPanel = !this.isShowPanel;
    },
    clickBmap(val) {
      //右击鼠标放标注
 
      this.markerPo = val.point;
    },
    setPoint(val) {
      
      const point = {
        lng: val.lon * 1,
        lat: val.lat * 1
      }
      this.center.lng = point.lng;
      this.center.lat = point.lat;
      this.markerPo = point;
      this.geoc.getLocation(new this.BMap.Point(point.lng, point.lat), (rs) => {
        if (rs) {
          this.address = rs.address;
        }
      });
    },
    dragend(val) {
      //标注拖拽完成获取坐标信息
      this.markerPo = val.point;
      this.geoc.getLocation(val.point, (rs) => {
        this.address = rs.address;
      });
    },




  },
};
</script>

<style lang="scss" scoped>
.map_div {
  margin-top: 20px;
  .bm-view {
    width: 100%;
    height: 400px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/MaintenanceWorkOrder/components/MapBox.vue